import { MenuItem, Select } from '@mui/material';
import { useState } from 'react';

const countries = [
    {
        code: 'US',
        name: {
            en: 'United States',
            ru: 'Соединенные Штаты',
            uz: "Amerika Qo'shma Shtatlari",
            tr: 'Amerika Birleşik Devletleri'
        },
        prefix: '+1'
    },
    {
        code: 'MY',
        name: {
            en: 'Malaysia',
            ru: 'Малайзия',
            uz: 'Malayziya',
            tr: 'Malezya'
        },
        prefix: '+60'
    },
    {
        code: 'GB',
        name: {
            en: 'United Kingdom',
            ru: 'Великобритания',
            uz: 'Buyuk Britaniya',
            tr: 'Birleşik Krallık'
        },
        prefix: '+44'
    },
    {
        code: 'AU',
        name: {
            en: 'Australia',
            ru: 'Австралия',
            uz: 'Avstraliya',
            tr: 'Avustralya'
        },
        prefix: '+61'
    },
    {
        code: 'CA',
        name: {
            en: 'Canada',
            ru: 'Канада',
            uz: 'Kanada',
            tr: 'Kanada'
        },
        prefix: '+1'
    },
    {
        code: 'Uz',
        name: {
            en: 'Uzbekistan',
            ru: 'Узбекистан',
            uz: "O'zbekiston",
            tr: 'Özbekistan'
        },
        prefix: '+998'
    },
    {
        code: 'Ru',
        name: {
            en: 'Russia',
            ru: 'Россия',
            uz: 'Rossiya',
            tr: 'Rusya'
        },
        prefix: '+7'
    },
    {
        code: 'Tr',
        name: {
            en: 'Turkey',
            ru: 'Турция',
            uz: 'Turkiya',
            tr: 'Türkiye'
        },
        prefix: '+90'
    }
];

interface Props {
    selectedCountry: any;
    onCountryChange: (country: any) => void;
    style?: any;
}

const SelectCountry = ({ selectedCountry, onCountryChange, style }: Props) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const defaultCountry = countries.find((country) => country.prefix === selectedCountry);
    const handleChange = (event: any) => {
        const selectedCountryCode = event.target.value as string;
        const selectedCountry = countries.find((country) => country.code === selectedCountryCode);
        if (selectedCountry) {
            onCountryChange(selectedCountry.prefix);
        }
    };

    return (
        <Select
            sx={{ borderColor: 'transparent', ...style }}
            labelId="country-select-label"
            id="country-select"
            onChange={handleChange}
            onOpen={handleOpen}
            defaultValue={defaultCountry?.code}
            onClose={handleClose}
            open={open}
            MenuProps={{
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                }
            }}
            variant="standard"
            disableUnderline
            color="secondary"
        >
            {countries.map((country: any) => (
                <MenuItem key={country.code} value={country.code}>
                    {country.code} ({country.prefix})
                </MenuItem>
            ))}
        </Select>
    );
};

export default SelectCountry;
